import { logger as LOG } from '@sweetgreen/garnish';

export const appsFlyerLogger = LOG.extend('AppsFlyer');

LOG.disable('AppsFlyer');
